import styled from 'styled-components';
import { ClickableRow as BaseClickableRow } from '../../../../CommonComponents/OPL/Table/Table';

export const ClickableRow = styled(BaseClickableRow)<{ isActive?: boolean }>(
  ({ theme, isActive }) => ({
    background: isActive ? theme.colors.primary[100] : 'transparent',
    '&:hover': {
      background: isActive ? theme.colors.primary[100] : theme.colors.neutral[100],
    },
  }),
);
